module.exports = "<div class=\"vui-tc\" ng-if=\"!loading\">\n  <div class=\"content-intercept-message\" ng-bind=\"message || '发生错误'\"></div>\n  <button class=\"button button-stable\" ng-click=\"reload()\" ng-bind=\"'重新加载'\"></button>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/directives/viewIntercept/default.html
// module id = 92
// module chunks = 0